import React, { Component } from "react";
import { withRouter } from "../common/with-router";
import { Row, Col, Breadcrumb, Container, Card } from "react-bootstrap";

class Contact extends Component {
  render() {
    return (
      <div className="mt-4">
        <Breadcrumb className="p-2 rounded">
          <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
          <Breadcrumb.Item active>Contato</Breadcrumb.Item>
        </Breadcrumb>

        <Container>
          {/* Header Minimalista */}
          <div className="my-5 text-center">
            <h2 className="font-weight-bold display-5">Vamos conversar?</h2>
            <p className="lead text-muted mx-auto" style={{ maxWidth: '700px' }}>
              Leve a experiência de replays profissionais para seus atletas e transforme sua arena em um centro de mídia digital.
            </p>
          </div>

          {/* Grid de Serviços */}
          <Row className="mb-5">
            {[
              {
                title: "Instalação Profissional",
                desc: "Câmeras Full HD instaladas estrategicamente para não perder nenhum detalhe.",
                icon: "bi-camera-video"
              },
              {
                title: "Plataforma Web",
                desc: "Seus replays disponíveis via navegador. Simples, rápido e sem instalar nada.",
                icon: "bi-globe"
              },
              {
                title: "Dados e Insights",
                desc: "Acompanhe métricas de engajamento e o perfil do público que frequenta seu espaço.",
                icon: "bi-graph-up-arrow"
              },
              {
                title: "Live Streaming",
                desc: "Soluções de transmissão ao vivo para campeonatos e eventos alcançarem o mundo.",
                icon: "bi-broadcast"
              }
            ].map((item, index) => (
              <Col md={6} lg={3} key={index} className="mb-4">
                <div className="h-100 p-3 text-center">
                  <div className="mb-3">
                    <i className={`bi ${item.icon} text-danger`} style={{ fontSize: '2.5rem' }}></i>
                  </div>
                  <h6 className="font-weight-bold mb-2">{item.title}</h6>
                  <p className="small text-muted mb-0">{item.desc}</p>
                </div>
              </Col>
            ))}
          </Row>

          {/* Área de Ação (CTA) */}
          <Row className="justify-content-center pb-5">
            <Col lg={8}>
              <Card className="border-0 shadow-lg overflow-hidden" style={{ borderRadius: '20px' }}>
                <Row className="g-0">
                  <Col md={5} className="bg-danger d-flex align-items-center justify-content-center p-4">
                    <div className="text-center">
                      <i className="bi bi-send-check text-white mb-2 d-block" style={{ fontSize: '3rem' }}></i>
                      <h4 className="font-weight-bold text-white">Solicite uma proposta</h4>
                    </div>
                  </Col>
                  <Col md={7} className="p-4 bg-white">
                    <p className="text-dark mb-4">
                      Envie um e-mail para nosso time comercial. Retornamos rapidamente com uma solução personalizada para o seu negócio.
                    </p>
                    <div className="d-flex align-items-center mb-3">
                      <div className="bg-light rounded-circle p-2 me-3">
                        <i className="bi bi-envelope-at text-danger fs-5"></i>
                      </div>
                      <a href="mailto:contato@replaypro.com.br" className="text-danger font-weight-bold h5 mb-0 text-decoration-none">
                        contato@replaypro.com.br
                      </a>
                    </div>
                    <div className="alert alert-warning border-0 small mb-0 py-2">
                      Dica: Informe seu interesse e deixe seu <strong>WhatsApp</strong> para agilizarmos o contato.
                    </div>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default withRouter(Contact);